import React from "react";

interface LoadingProps {
  data?: {};
}

const OverviewLoaders: React.FC<LoadingProps> = ({ data }) => {
  return (
    <div className="px-3 md:px-6 grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-2  gap-4 mt-3 md:mt-4">
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          className="w-full h-full flex flex-col justify-between pt-3 bg-[#ffffff] border border-[#EAECF0] rounded-lg"
        >
          <div className="">
            <div className="whitespace-nowrap font-medium flex flex-col text-gray-900 animate-pulse px-3 py-[18px]">
              {i == 4 ? (
                <div className="flex justify-between items-center">
                  <span className="h-5 bg-[#E6EEF5] inline-block w-[30%] rounded-md"></span>
                  <span className="h-5 bg-[#E6EEF5] inline-block w-[30%] rounded-md"></span>
                </div>
              ) : (
                <span className="h-5 bg-[#E6EEF5] inline-block w-[30%] rounded-md"></span>
              )}
              <span
                className={`h-5 bg-[#E6EEF5] inline-block ${i == 4 ? "w-[100%]" : "w-[70%]"} rounded-md mt-3`}
              ></span>
              {i == 4 ? (
                <div className="flex justify-between items-center mt-3">
                  <span className="h-5 bg-[#E6EEF5] inline-block w-[30%] rounded-md"></span>
                  <span className="h-5 bg-[#E6EEF5] inline-block w-[30%] rounded-md"></span>
                </div>
              ) : (
                <>
                  {i < 3 && (
                    <span className="h-5 bg-[#E6EEF5] inline-block w-[10%] rounded-md mt-3"></span>
                  )}
                </>
              )}
            </div>
            {i == 2 && (
              <div className="animate-pulse px-3 py-2">
                <div className="animate-pulse relative w-full flex justify-center items-center">
                  <span className="h-[200px] bg-[#E6EEF5] inline-block w-[200px] rounded-full"></span>
                  <span className="h-[100px] bg-white absolute inline-block w-[100px] rounded-full"></span>
                </div>
              </div>
            )}
          </div>
          <div className="flex w-full mt-auto bg-[#F9FAFB] justify-center items-center rounded-b-md border-t border-t-[#EAECF0] ">
            <h6 className="w-full text-center text-[#667085] text-[14px] font-medium pt-[15px] pb-[15px]">
              <span className="h-5 bg-[#E6EEF5] inline-block w-[30%] rounded-md">
                {" "}
              </span>
            </h6>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OverviewLoaders;
